import SubtradeChannel from './SubtradeChannel'
import BusinessType from './BusinessType'
import CustomerType from './CustomerType'
import OutletAcquisitionType from './OutletAcquisitionType'
import ProspectSource from './ProspectSource'
export class GeneralInfo {
    RequestID: number;
    CustomerNumber: string;
    BusinessName: string;
    OldZRPartnerEmployeeID?: number;
    EmployeeID?: number;
    ReportingHierarchyEmployeeID?: number;
    StoreNumber: string;
    LegalName: string;
    VendingMachineLocation: string;
    Language: string;
    Fax: string;
    Email: string;
    CMA: boolean;
    ProjectNumber: string;
    SubtradeChannelID?: number;
    SubtradeChannel?: SubtradeChannel;
    BusinessTypeID?: number;
    BusinessType?: BusinessType;
    IncludeEquipmentInstall?: boolean;
    IncludeSurveyRequest?: boolean;
    CustomerTypeID?: number;
    CustomerType?: CustomerType;
    IncludeOwnershipChange?: boolean;
    ExistingCustomerNumber?: string;
    SerialNumbers: string[];
    WillCustomerSellDrPepper?: boolean;
    AllCustomers: boolean;
    NewBusinessName: string;
    NewLegalName: string;
    OldZKPartnerEmployeeID?: number;
    ChangeCustomerToSecondaryVolume?: boolean;
    OutletAcquisitionTypeID?: number;
    OutletAcquisitionType?: OutletAcquisitionType;
    ProspectSourceID?: number;
    ProspectSource?: ProspectSource;
    OverallAccountPhoneNumber?: string;
}

export default GeneralInfo;
